/* unplugin-vue-components disabled */import { render } from "./MenuMobile.vue?vue&type=template&id=f1f6b448&scoped=true&ts=true"
import script from "./MenuMobile.vue?vue&type=script&lang=ts"
export * from "./MenuMobile.vue?vue&type=script&lang=ts"

import "./MenuMobile.vue?vue&type=style&index=0&id=f1f6b448&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1f6b448"]])

export default __exports__